import React, { useEffect } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { HookSection } from '../components/HookSection';
import { PainSection } from '../components/PainSection';
import { RevelationSection } from '../components/RevelationSection';
import { PowerBullets } from '../components/PowerBullets';
import { ClosingSection } from '../components/ClosingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CtaSection } from '../components/CtaSection';
import { trackPageView } from '../utils/pixel';
export function LandingPage() {
  useEffect(() => {
    trackPageView();
  }, []);
  return <main className="min-h-screen w-full bg-[#FAF7F2] selection:bg-[#C9A96E] selection:text-white" data-id="element-161">
      {/* Urgency Bar - Sticky at top */}
      <UrgencyBar data-id="element-162" />

      {/* Navigation / Brand Header */}
      <nav className="w-full py-4 px-5 flex justify-center border-b border-[#1C1C1C]/5 bg-[#FAF7F2]" data-id="element-163">
        <div className="text-xl font-serif font-bold tracking-tighter text-[#1C1C1C]" data-id="element-164">
          HOGAR <span className="text-[#C9A96E] font-normal italic" data-id="element-165">de</span>{' '}
          REVISTA
        </div>
      </nav>

      {/* Page Sections */}
      <HeroSection data-id="element-166" />
      <HookSection data-id="element-167" />
      <PainSection data-id="element-168" />
      <RevelationSection data-id="element-169" />
      <PowerBullets data-id="element-170" />
      <ClosingSection data-id="element-171" />
      <TestimonialsSection data-id="element-172" />
      <CtaSection data-id="element-173" />

      {/* Footer */}
      <footer className="bg-[#1C1C1C] text-[#FAF7F2]/40 py-10 px-5 border-t border-[#FAF7F2]/10" data-id="element-174">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-175">
          <div className="text-sm font-serif" data-id="element-176">
            © 2024 Hogar de Revista. Todos los derechos reservados.
          </div>
        </div>
      </footer>
    </main>;
}